import { JSONAPICache } from '@warp-drive/json-api';
import { useLegacyStore } from '@warp-drive/legacy';

import AuthHandler from 'umg-ember-backend/data/handlers/auth';
import RestHandler from 'umg-ember-backend/data/handlers/rest';

const Store = useLegacyStore({
  legacyRequests: true,
  linksMode: false,
  cache: JSONAPICache,
  schemas: [
    // -- your schemas here for
    // anything migrated off of Model
  ],
  handlers: [
    AuthHandler,
    RestHandler,
    // Fetch, LegacyNetworkHandler, and CacheHandler
    // are automatically provided when needed
  ],
});

export default Store;
